import AuthRepository from '../repositories/AuthRepository';
import UserService from './UserService';

export default class AuthService {
  constructor() {
    this.authRepository = new AuthRepository();
    this.userService = new UserService();
  }

  signInWithEmailPassword(email, password) {
    return this.authRepository.signInWithEmailPassword(email, password);
  }

  updateAndSignIn({ password, token, organizationId, user }) {
    return this.authRepository.updateAndSignIn({
      password,
      token,
      organizationId,
      user,
    });
  }

  updateAndSignInV2({ password, organizationId, userId, token, user }) {
    return this.authRepository.updateAndSignInV2({ password, organizationId, userId, token, user });
  }

  getInviteAcceptanceContext(organizationId, userId, token) {
    return this.authRepository.getInviteAcceptanceContext(organizationId, userId, token);
  }

  completeRegistration({ password, organizationId, user }) {
    return this.authRepository.completeRegistration({ password, organizationId, user });
  }

  getOnboardingContext(organizationId) {
    return this.authRepository.getOnboardingContext(organizationId);
  }

  requestPasswordReset(email) {
    return this.authRepository.requestPasswordReset(email);
  }

  resetPassword(code, newPassword) {
    return this.authRepository.resetPassword(code, newPassword);
  }

  getApiKey(organizationId) {
    return this.authRepository.getApiKey(organizationId);
  }

  createRestApiV2Credential(payload) {
    return this.authRepository.createRestApiV2Credential(payload);
  }

  createRestApiV2EventSubscription(payload) {
    return this.authRepository.createRestApiV2EventSubscription(payload);
  }

  async resendInvitation(organizationId, userId) {
    return await this.authRepository.resendInvitation(organizationId, userId);
  }

  async deleteInvitation(organizationId, userId) {
    return await this.authRepository.deleteInvitation(organizationId, userId);
  }
}
